import _slicedToArray from "/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.string.trim-end.js";
import * as t from "react";

function e() {
  return (e = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var n = ["children", "options"],
    r = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "className", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce(function (t, e) {
  return t[e.toLowerCase()] = e, t;
}, {
  for: "htmlFor"
}),
    o = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: " ",
  quot: "“"
},
    c = ["style", "script"],
    a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,
    u = /mailto:/i,
    i = /\n{2,}$/,
    l = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,
    s = /^ *> ?/gm,
    _ = /^ {2,}\n/,
    f = /^(?:( *[-*_]) *){3,}(?:\n *)+\n/,
    d = /^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,
    p = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,
    g = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
    m = /^(?:\n *)*\n/,
    y = /\r\n?/g,
    h = /^\[\^([^\]]+)](:.*)\n/,
    k = /^\[\^([^\]]+)]/,
    x = /\f/g,
    b = /^\s*?\[(x|\s)\]/,
    v = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,
    S = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,
    $ = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,
    w = /&([a-z]+);/g,
    z = /^<!--[\s\S]*?(?:-->)/,
    E = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/,
    A = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,
    R = /^\{.*\}$/,
    I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
    M = /^<([^ >]+@[^ >]+)>/,
    O = /^<([^ >]+:\/[^ >]+)>/,
    B = / *\n+$/,
    L = /(?:^|\n)( *)$/,
    T = /-([a-z])?/gi,
    j = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,
    C = /^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,
    D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/,
    N = /^\[([^\]]*)\] ?\[([^\]]*)\]/,
    Z = /(\[|\])/g,
    F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,
    P = /\t/g,
    G = /^ *\| */,
    H = /(^ *\||\| *$)/g,
    q = / *$/,
    U = /^ *:-+: *$/,
    V = /^ *:-+ *$/,
    W = /^ *-+: *$/,
    Q = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,
    X = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,
    J = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,
    K = /^\\([^0-9A-Za-z\s])/,
    Y = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,
    tt = /^\n+/,
    et = /^([ \t]*)/,
    nt = /\\([^0-9A-Z\s])/gi,
    rt = new RegExp("^( *)((?:[*+-]|\\d+\\.)) +"),
    ot = new RegExp("^( *)((?:[*+-]|\\d+\\.)) +[^\\n]*(?:\\n(?!\\1(?:[*+-]|\\d+\\.) )[^\\n]*)*(\\n|$)", "gm"),
    ct = new RegExp("^( *)((?:[*+-]|\\d+\\.)) [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1(?:[*+-]|\\d+\\.) (?!(?:[*+-]|\\d+\\.) ))\\n*|\\s*\\n*$)"),
    at = "(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*",
    ut = new RegExp("^\\[(" + at + ")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),
    it = new RegExp("^!\\[(" + at + ")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),
    lt = [l, p, d, v, S, z, ot, ct, j],
    st = [].concat(lt, [/^[^\n]+(?:  \n|\n{2,})/, $, A]);

function _t(t) {
  return t.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}

function ft(t) {
  return W.test(t) ? "right" : U.test(t) ? "center" : V.test(t) ? "left" : null;
}

function dt(t, e, n) {
  var r = n.t;
  n.t = !0;
  var o = e(t.trim(), n);
  n.t = r;
  var c = [[]];
  return o.forEach(function (t, e) {
    "tableSeparator" === t.type ? 0 !== e && e !== o.length - 1 && c.push([]) : ("text" !== t.type || null != o[e + 1] && "tableSeparator" !== o[e + 1].type || (t.content = t.content.replace(q, "")), c[c.length - 1].push(t));
  }), c;
}

function pt(t, e, n) {
  n.o = !0;

  var r = dt(t[1], e, n),
      o = t[2].replace(H, "").split("|").map(ft),
      c = function (t, e, n) {
    return t.trim().split("\n").map(function (t) {
      return dt(t, e, n);
    });
  }(t[3], e, n);

  return n.o = !1, {
    align: o,
    cells: c,
    header: r,
    type: "table"
  };
}

function gt(t, e) {
  return null == t.align[e] ? {} : {
    textAlign: t.align[e]
  };
}

function mt(t) {
  return function (e, n) {
    return n.o ? t.exec(e) : null;
  };
}

function yt(t) {
  return function (e, n) {
    return n.o || n.u ? t.exec(e) : null;
  };
}

function ht(t) {
  return function (e, n) {
    return n.o || n.u ? null : t.exec(e);
  };
}

function kt(t) {
  return function (e) {
    return t.exec(e);
  };
}

function xt(t, e, n) {
  if (e.o || e.u) return null;
  if (n && !n.endsWith("\n")) return null;
  var r = "";
  t.split("\n").every(function (t) {
    return !lt.some(function (e) {
      return e.test(t);
    }) && (r += t + "\n", t.trim());
  });
  var o = r.trimEnd();
  return "" == o ? null : [r, o];
}

function bt(t) {
  try {
    if (decodeURIComponent(t).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data):/i)) return null;
  } catch (t) {
    return null;
  }

  return t;
}

function vt(t) {
  return t.replace(nt, "$1");
}

function St(t, e, n) {
  var r = n.o || !1,
      o = n.u || !1;
  n.o = !0, n.u = !0;
  var c = t(e, n);
  return n.o = r, n.u = o, c;
}

function $t(t, e, n) {
  var r = n.o || !1,
      o = n.u || !1;
  n.o = !1, n.u = !0;
  var c = t(e, n);
  return n.o = r, n.u = o, c;
}

function wt(t, e, n) {
  return n.o = !1, t(e + "\n\n", n);
}

var zt = function zt(t, e, n) {
  return {
    content: St(e, t[1], n)
  };
};

function Et() {
  return {};
}

function At() {
  return null;
}

function Rt() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  return t.filter(Boolean).join(" ");
}

function It(t, e, n) {
  var r = t;
  var o = e.split(".");

  for (; o.length && (r = r[o[0]], void 0 !== r);) {
    o.shift();
  }

  return r || n;
}

var Mt;

function Ot(n) {
  var H = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  H.overrides = H.overrides || {}, H.slugify = H.slugify || _t, H.namedCodesToUnicode = H.namedCodesToUnicode ? e({}, o, H.namedCodesToUnicode) : o;
  var q = H.createElement || t.createElement;

  function U(t, n) {
    var o = It(H.overrides, "".concat(t, ".props"), {});

    for (var _len2 = arguments.length, r = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      r[_key2 - 2] = arguments[_key2];
    }

    return q.apply(void 0, [function (t, e) {
      var n = It(e, t);
      return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : It(e, "".concat(t, ".component"), t) : t;
    }(t, H.overrides), e({}, n, o, {
      className: Rt(null == n ? void 0 : n.className, o.className) || void 0
    })].concat(r));
  }

  function V(e) {
    var n = !1;
    H.forceInline ? n = !0 : H.forceBlock || (n = !1 === F.test(e));
    var r = dt(ft(n ? e : "".concat(e.trimEnd().replace(tt, ""), "\n\n"), {
      o: n
    }));

    for (; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();) {
      r.pop();
    }

    if (null === H.wrapper) return r;
    var o = H.wrapper || (n ? "span" : "div");
    var c;
    if (r.length > 1 || H.forceWrapper) c = r;else {
      if (1 === r.length) return c = r[0], "string" == typeof c ? U("span", {
        key: "outer"
      }, c) : c;
      c = null;
    }
    return t.createElement(o, {
      key: "outer"
    }, c);
  }

  function W(e) {
    var n = e.match(a);
    return n ? n.reduce(function (e, n, o) {
      var c = n.indexOf("=");

      if (-1 !== c) {
        var _a = function (t) {
          return -1 !== t.indexOf("-") && null === t.match(E) && (t = t.replace(T, function (t, e) {
            return e.toUpperCase();
          })), t;
        }(n.slice(0, c)).trim(),
            _u = function (t) {
          var e = t[0];
          return ('"' === e || "'" === e) && t.length >= 2 && t[t.length - 1] === e ? t.slice(1, -1) : t;
        }(n.slice(c + 1).trim()),
            _i = r[_a] || _a,
            _l = e[_i] = function (t, e) {
          return "style" === t ? e.split(/;\s?/).reduce(function (t, e) {
            var n = e.slice(0, e.indexOf(":"));
            return t[n.replace(/(-[a-z])/g, function (t) {
              return t[1].toUpperCase();
            })] = e.slice(n.length + 1).trim(), t;
          }, {}) : "href" === t ? bt(e) : (e.match(R) && (e = e.slice(1, e.length - 1)), "true" === e || "false" !== e && e);
        }(_a, _u);

        "string" == typeof _l && ($.test(_l) || A.test(_l)) && (e[_i] = t.cloneElement(V(_l.trim()), {
          key: o
        }));
      } else "style" !== n && (e[r[n] || n] = !0);

      return e;
    }, {}) : void 0;
  }

  var nt = [],
      at = {},
      lt = {
    blockQuote: {
      i: ht(l),
      l: Mt.HIGH,
      _: function _(t, e, n) {
        return {
          content: e(t[0].replace(s, ""), n)
        };
      },
      p: function p(t, e, n) {
        return U("blockquote", {
          key: n.g
        }, e(t.content, n));
      }
    },
    breakLine: {
      i: kt(_),
      l: Mt.HIGH,
      _: Et,
      p: function p(t, e, n) {
        return U("br", {
          key: n.g
        });
      }
    },
    breakThematic: {
      i: ht(f),
      l: Mt.HIGH,
      _: Et,
      p: function p(t, e, n) {
        return U("hr", {
          key: n.g
        });
      }
    },
    codeBlock: {
      i: ht(p),
      l: Mt.MAX,
      _: function _(t) {
        return {
          content: t[0].replace(/^ {4}/gm, "").replace(/\n+$/, ""),
          lang: void 0
        };
      },
      p: function p(t, e, n) {
        return U("pre", {
          key: n.g
        }, U("code", {
          className: t.lang ? "lang-".concat(t.lang) : ""
        }, t.content));
      }
    },
    codeFenced: {
      i: ht(d),
      l: Mt.MAX,
      _: function _(t) {
        return {
          content: t[3],
          lang: t[2] || void 0,
          type: "codeBlock"
        };
      }
    },
    codeInline: {
      i: yt(g),
      l: Mt.LOW,
      _: function _(t) {
        return {
          content: t[2]
        };
      },
      p: function p(t, e, n) {
        return U("code", {
          key: n.g
        }, t.content);
      }
    },
    footnote: {
      i: ht(h),
      l: Mt.MAX,
      _: function _(t) {
        return nt.push({
          footnote: t[2],
          identifier: t[1]
        }), {};
      },
      p: At
    },
    footnoteReference: {
      i: mt(k),
      l: Mt.HIGH,
      _: function _(t) {
        return {
          content: t[1],
          target: "#".concat(H.slugify(t[1]))
        };
      },
      p: function p(t, e, n) {
        return U("a", {
          key: n.g,
          href: bt(t.target)
        }, U("sup", {
          key: n.g
        }, t.content));
      }
    },
    gfmTask: {
      i: mt(b),
      l: Mt.HIGH,
      _: function _(t) {
        return {
          completed: "x" === t[1].toLowerCase()
        };
      },
      p: function p(t, e, n) {
        return U("input", {
          checked: t.completed,
          key: n.g,
          readOnly: !0,
          type: "checkbox"
        });
      }
    },
    heading: {
      i: ht(v),
      l: Mt.HIGH,
      _: function _(t, e, n) {
        return {
          content: St(e, t[2], n),
          id: H.slugify(t[2]),
          level: t[1].length
        };
      },
      p: function p(t, e, n) {
        return t.tag = "h".concat(t.level), U(t.tag, {
          id: t.id,
          key: n.g
        }, e(t.content, n));
      }
    },
    headingSetext: {
      i: ht(S),
      l: Mt.MAX,
      _: function _(t, e, n) {
        return {
          content: St(e, t[1], n),
          level: "=" === t[2] ? 1 : 2,
          type: "heading"
        };
      }
    },
    htmlComment: {
      i: kt(z),
      l: Mt.HIGH,
      _: function _() {
        return {};
      },
      p: At
    },
    image: {
      i: yt(it),
      l: Mt.HIGH,
      _: function _(t) {
        return {
          alt: t[1],
          target: vt(t[2]),
          title: t[3]
        };
      },
      p: function p(t, e, n) {
        return U("img", {
          key: n.g,
          alt: t.alt || void 0,
          title: t.title || void 0,
          src: bt(t.target)
        });
      }
    },
    link: {
      i: mt(ut),
      l: Mt.LOW,
      _: function _(t, e, n) {
        return {
          content: $t(e, t[1], n),
          target: vt(t[2]),
          title: t[3]
        };
      },
      p: function p(t, e, n) {
        return U("a", {
          key: n.g,
          href: bt(t.target),
          title: t.title
        }, e(t.content, n));
      }
    },
    linkAngleBraceStyleDetector: {
      i: mt(O),
      l: Mt.MAX,
      _: function _(t) {
        return {
          content: [{
            content: t[1],
            type: "text"
          }],
          target: t[1],
          type: "link"
        };
      }
    },
    linkBareUrlDetector: {
      i: function i(t, e) {
        return e.m ? null : mt(I)(t, e);
      },
      l: Mt.MAX,
      _: function _(t) {
        return {
          content: [{
            content: t[1],
            type: "text"
          }],
          target: t[1],
          title: void 0,
          type: "link"
        };
      }
    },
    linkMailtoDetector: {
      i: mt(M),
      l: Mt.MAX,
      _: function _(t) {
        var e = t[1],
            n = t[1];
        return u.test(n) || (n = "mailto:" + n), {
          content: [{
            content: e.replace("mailto:", ""),
            type: "text"
          }],
          target: n,
          type: "link"
        };
      }
    },
    list: {
      i: function i(t, e, n) {
        var r = L.exec(n);
        return !r || !e.h && e.o ? null : ct.exec(t = r[1] + t);
      },
      l: Mt.HIGH,
      _: function _(t, e, n) {
        var r = t[2],
            o = r.length > 1,
            c = o ? +r : void 0,
            a = t[0].replace(i, "\n").match(ot);
        var u = !1;
        return {
          items: a.map(function (t, r) {
            var o = rt.exec(t)[0].length,
                c = new RegExp("^ {1," + o + "}", "gm"),
                i = t.replace(c, "").replace(rt, ""),
                l = r === a.length - 1,
                s = -1 !== i.indexOf("\n\n") || l && u;
            u = s;
            var _ = n.o,
                f = n.h;
            var d;
            n.h = !0, s ? (n.o = !1, d = i.replace(B, "\n\n")) : (n.o = !0, d = i.replace(B, ""));
            var p = e(d, n);
            return n.o = _, n.h = f, p;
          }),
          ordered: o,
          start: c
        };
      },
      p: function p(t, e, n) {
        return U(t.ordered ? "ol" : "ul", {
          key: n.g,
          start: t.start
        }, t.items.map(function (t, r) {
          return U("li", {
            key: r
          }, e(t, n));
        }));
      }
    },
    newlineCoalescer: {
      i: ht(m),
      l: Mt.LOW,
      _: Et,
      p: function p() {
        return "\n";
      }
    },
    paragraph: {
      i: xt,
      l: Mt.LOW,
      _: zt,
      p: function p(t, e, n) {
        return U("p", {
          key: n.g
        }, e(t.content, n));
      }
    },
    ref: {
      i: mt(C),
      l: Mt.MAX,
      _: function _(t) {
        return at[t[1]] = {
          target: t[2],
          title: t[4]
        }, {};
      },
      p: At
    },
    refImage: {
      i: yt(D),
      l: Mt.MAX,
      _: function _(t) {
        return {
          alt: t[1] || void 0,
          ref: t[2]
        };
      },
      p: function p(t, e, n) {
        return U("img", {
          key: n.g,
          alt: t.alt,
          src: bt(at[t.ref].target),
          title: at[t.ref].title
        });
      }
    },
    refLink: {
      i: mt(N),
      l: Mt.MAX,
      _: function _(t, e, n) {
        return {
          content: e(t[1], n),
          fallbackContent: e(t[0].replace(Z, "\\$1"), n),
          ref: t[2]
        };
      },
      p: function p(t, e, n) {
        return at[t.ref] ? U("a", {
          key: n.g,
          href: bt(at[t.ref].target),
          title: at[t.ref].title
        }, e(t.content, n)) : U("span", {
          key: n.g
        }, e(t.fallbackContent, n));
      }
    },
    table: {
      i: ht(j),
      l: Mt.HIGH,
      _: pt,
      p: function p(t, e, n) {
        return U("table", {
          key: n.g
        }, U("thead", null, U("tr", null, t.header.map(function (r, o) {
          return U("th", {
            key: o,
            style: gt(t, o)
          }, e(r, n));
        }))), U("tbody", null, t.cells.map(function (r, o) {
          return U("tr", {
            key: o
          }, r.map(function (r, o) {
            return U("td", {
              key: o,
              style: gt(t, o)
            }, e(r, n));
          }));
        })));
      }
    },
    tableSeparator: {
      i: function i(t, e) {
        return e.t ? G.exec(t) : null;
      },
      l: Mt.HIGH,
      _: function _() {
        return {
          type: "tableSeparator"
        };
      },
      p: function p() {
        return " | ";
      }
    },
    text: {
      i: kt(Y),
      l: Mt.MIN,
      _: function _(t) {
        return {
          content: t[0].replace(w, function (t, e) {
            return H.namedCodesToUnicode[e] ? H.namedCodesToUnicode[e] : t;
          })
        };
      },
      p: function p(t) {
        return t.content;
      }
    },
    textBolded: {
      i: yt(Q),
      l: Mt.MED,
      _: function _(t, e, n) {
        return {
          content: e(t[2], n)
        };
      },
      p: function p(t, e, n) {
        return U("strong", {
          key: n.g
        }, e(t.content, n));
      }
    },
    textEmphasized: {
      i: yt(X),
      l: Mt.LOW,
      _: function _(t, e, n) {
        return {
          content: e(t[2], n)
        };
      },
      p: function p(t, e, n) {
        return U("em", {
          key: n.g
        }, e(t.content, n));
      }
    },
    textEscaped: {
      i: yt(K),
      l: Mt.HIGH,
      _: function _(t) {
        return {
          content: t[1],
          type: "text"
        };
      }
    },
    textStrikethroughed: {
      i: yt(J),
      l: Mt.LOW,
      _: zt,
      p: function p(t, e, n) {
        return U("del", {
          key: n.g
        }, e(t.content, n));
      }
    }
  };
  !0 !== H.disableParsingRawHTML && (lt.htmlBlock = {
    i: kt($),
    l: Mt.HIGH,
    _: function _(t, e, n) {
      var _t$3$match = t[3].match(et),
          _t$3$match2 = _slicedToArray(_t$3$match, 2),
          r = _t$3$match2[1],
          o = new RegExp("^".concat(r), "gm"),
          a = t[3].replace(o, ""),
          u = (i = a, st.some(function (t) {
        return t.test(i);
      }) ? wt : St);

      var i;
      var l = t[1].toLowerCase(),
          s = -1 !== c.indexOf(l);
      n.m = n.m || "a" === l;

      var _ = s ? t[3] : u(e, a, n);

      return n.m = !1, {
        attrs: W(t[2]),
        content: _,
        noInnerParse: s,
        tag: s ? l : t[1]
      };
    },
    p: function p(t, n, r) {
      return U(t.tag, e({
        key: r.g
      }, t.attrs), t.noInnerParse ? t.content : n(t.content, r));
    }
  }, lt.htmlSelfClosing = {
    i: kt(A),
    l: Mt.HIGH,
    _: function _(t) {
      return {
        attrs: W(t[2] || ""),
        tag: t[1]
      };
    },
    p: function p(t, n, r) {
      return U(t.tag, e({}, t.attrs, {
        key: r.g
      }));
    }
  });

  var ft = function (t) {
    var e = Object.keys(t);

    function n(r, o) {
      var c = [],
          a = "";

      for (; r;) {
        var _u2 = 0;

        for (; _u2 < e.length;) {
          var _i2 = e[_u2],
              _l2 = t[_i2],
              _s = _l2.i(r, o, a);

          if (_s) {
            var _t2 = _s[0];
            r = r.substring(_t2.length);

            var _e = _l2._(_s, n, o);

            null == _e.type && (_e.type = _i2), c.push(_e), a = _t2;
            break;
          }

          _u2++;
        }
      }

      return c;
    }

    return e.sort(function (e, n) {
      var r = t[e].l,
          o = t[n].l;
      return r !== o ? r - o : e < n ? -1 : 1;
    }), function (t, e) {
      return n(function (t) {
        return t.replace(y, "\n").replace(x, "").replace(P, "    ");
      }(t), e);
    };
  }(lt),
      dt = (Ot = function (t) {
    return function (e, n, r) {
      return t[e.type].p(e, n, r);
    };
  }(lt), function t(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (Array.isArray(e)) {
      var _r = n.g,
          _o = [];

      var _c = !1;

      for (var _r2 = 0; _r2 < e.length; _r2++) {
        n.g = _r2;

        var _a2 = t(e[_r2], n),
            _u3 = "string" == typeof _a2;

        _u3 && _c ? _o[_o.length - 1] += _a2 : null !== _a2 && _o.push(_a2), _c = _u3;
      }

      return n.g = _r, _o;
    }

    return Ot(e, t, n);
  });

  var Ot;
  var Bt = V(n);
  return nt.length ? U("div", null, Bt, U("footer", {
    key: "footer"
  }, nt.map(function (t) {
    return U("div", {
      id: H.slugify(t.identifier),
      key: t.identifier
    }, t.identifier, dt(ft(t.footnote, {
      o: !0
    })));
  }))) : Bt;
}

!function (t) {
  t[t.MAX = 0] = "MAX", t[t.HIGH = 1] = "HIGH", t[t.MED = 2] = "MED", t[t.LOW = 3] = "LOW", t[t.MIN = 4] = "MIN";
}(Mt || (Mt = {}));
export default (function (e) {
  var r = e.children,
      o = e.options,
      c = function (t, e) {
    if (null == t) return {};
    var n,
        r,
        o = {},
        c = Object.keys(t);

    for (r = 0; r < c.length; r++) {
      e.indexOf(n = c[r]) >= 0 || (o[n] = t[n]);
    }

    return o;
  }(e, n);

  return t.cloneElement(Ot(r, o), c);
});
export { Ot as compiler };